import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import velocityLogo from "../../pics/VelocitYLogo.png";
import SimultaniousIcon from "../../pics/SimultaniousIcon.png";
import HasselFreeIcon from "../../pics/hasselFreeicon.png";
import CreatorIcon from "../../pics/madeCreatorsIcon.png";
import problem from "../../pics/theProblemImg.png";
import solution from "../../pics/LandingPageGraphics.png";
import CreateGoalFor from "../../pics/CreateGoalForImg.png";
import theProblemHeadImg from "../../pics/TheProblemHeadImage.png";
import theSolutionHeadImg from "../../pics/theSolutionHeadImg.png";
import creategoalHeadImg from "../../pics/creategoalHeadImg.png";
import LandingTopLeft from "../../pics/LandingPageGraphicTopLeft.png";
import LandingTopRight from "../../pics/LandingPageGraphicTopRight.png";
import Faqs from "../../components/Homecomponents/NewFaqs";
import AnimatedNumber from "../../components/Homecomponents/AnimatedNumber";
import HomeCarousel from "../../components/Homecomponents/HomeCarousel";

function NewHome() {
  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const faqsRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const scrollToSection = () => {
      switch (location.hash) {
        case "#home":
          homeRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        case "#about":
          aboutRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        case "#faqs":
          faqsRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        default:
          break;
      }
    };

    scrollToSection();
  }, [location]);

  const navigate = useNavigate();
  const [scrollPosition, setScrollPosition] = useState(0);

  const handleScroll = () => {
    const totalScroll = window.scrollY;
    setScrollPosition(totalScroll);
  };
  const handleClick = () => {
    navigate("/signup/");
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Calculate yellowHeight within this specific section
  const yellowHeight =
    Math.min(scrollPosition - 900, 1500) >= 0
      ? Math.min(scrollPosition - 900, 1500)
      : 0;

  return (
    <>
      <div className=" bg-[#030021] ">
        <div className="relative max-w-[1600px] mx-auto  ">
          <img
            src={LandingTopLeft}
            className="lg:block hidden absolute z-[4] left-0 top-[-1rem]  "
            alt=""
          />
          <img
            src={LandingTopRight}
            className="lg:block hidden absolute z-[4] right-0 top-[-1rem]  "
            alt=""
          />
          <div
            className="relative z-[5] grid grid-cols-1 max-w-[570px] w-full mx-auto    px-4 md:pt-[7rem] pt-[5rem] md:pb-[3rem]"
            id="home"
            ref={homeRef}
          >
            <div className="flex justify-center flex-col md:space-y-8 space-y-5  items-center w-full ">
              <h1 className="CustomHeroHead text-white text-center ">
                Multiple Tip Goals{" "}
                <span className="inline-block text-[#00FF8F] ">
                  All at Once
                </span>
              </h1>
              <h2 className="CustomHeroPara text-center text-white ">
                The<span className="font-semibold"> only </span>
                platform built for simultaneous tipping goals
              </h2>
              <div className=" relative  md:max-w-[550px] w-full ">
                <label className="absolute sm:top-[.9rem] top-[0.8rem] sm:left-6 left-4 sm:text-[25px] text-[18px] font-semibold leading-[31px] tracking-normal text-left text-[#35334D]  ">
                  sponsa.app/
                </label>
                <input
                  type="text"
                  placeholder="yourname"
                  className="input py-7 rounded-[10px]  bg-white w-full lg:max-w-[550px]  sm:pl-[10.8rem] pl-[7rem] placeholder:sm:text-[25px] placeholder:text-[18px]  placeholder:font-normal placeholder:sm:leading-[31px] placeholder:tracking-normal placeholder:text-left  placeholder:text-[#35334D99] text-black  sm:text-[25px] text-[18px]   font-normal leading-[26px] tracking-normal text-left sm:pr-[8rem] pr-[5rem] "
                />
                <button
                  className=" onest HoverDarker rounded-[10px] top-[5px] right-2 absolute sm:px-8 px-4 py-3 bg-[#00FF8F] hover:bg-[#00FF8F]   text-black border-none btn"
                  onClick={() => navigate("/signup/")}
                >
                  Claim
                </button>
                <h6 className="   text-[20px] font-light leading-[24px] tracking-normal text-center text-white mt-3">
                  We’ll never share your info with anyone.
                </h6>
              </div>
              <div className="flex items-center  gap-3">
                <img src={velocityLogo} alt="" className="w-[75px]" />
                <h4 className="sm:text-[25px] text-[20px] font-semibold leading-[31px] tracking-normal text-left text-white">
                  Powered by{" "}
                  <Link
                    className="underline"
                    to={"https://www.youtube.com/@velocityofcl"}
                    target="_blank"
                  >
                    Velo City
                  </Link>
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div className="  md:py-6  mt-[1rem]">
          <div className="flex justify-between  md:flex-nowrap flex-wrap md:max-w-[1260px] max-w-[550px] md:mx-auto ml-auto gap-4 px-4 [&>div_div]:mb-4 [&>div]:pt-3   ">
            <div>
              <div className="flex items-center gap-2">
                <img src={SimultaniousIcon} alt="" />
                <p className="CustomCardHead  text-[#F24F96]">
                  Simultaneous Tip Goals
                </p>
              </div>
              <p className="CustomCardPara sm:max-w-[400px]">
                The <span className="font-semibold"> only </span> place you can
                set up multiple tip goals for projects (or anything you want!),
                all at once.
              </p>
            </div>
            <div className="">
              <div className="flex items-center gap-2">
                <img src={HasselFreeIcon} alt="" />
                <p className="CustomCardHead  text-[#33B4FF]">
                  Hassle-free Payment
                </p>
              </div>
              <p className="CustomCardPara sm:max-w-[260px]">
                Payments made directly from your fans to you (powered by
                PayPal).
              </p>
            </div>
            <div>
              <div className="flex items-center gap-2">
                <img src={CreatorIcon} alt="" />
                <p className="CustomCardHead  text-[#FFD50E]   ">
                  Made for Creators, by Creators
                </p>
              </div>
              <p className="CustomCardPara sm:max-w-[428px]">
                As creators ourselves, we understand your pain when it comes to
                using tipping platforms to raise funds for projects. We’ve got
                your back.
              </p>
            </div>
          </div>
        </div>

        <div
          className="mx-auto w-full flex justify-center md:pt-[6rem] md:pb-[4rem] py-[5rem]  "
          id="about"
          ref={aboutRef}
        >
          <button
            className=" HoverDarker rounded-[50px] px-11 py-3   bg-[#00FF8F]  text-[25px]  font-bold text-black leading-[30px] tracking-normal text-center border-none    CustomButtonAnim "
            onClick={handleClick}
          >
            Start Now
          </button>
        </div>
        <div className=" py-[4rem]  ">
          <HomeCarousel />
        </div>

        <div className="relative grid grid-cols-1 max-w-[1100px] mx-auto px-4 pb-[4rem]">
          <div
            className="absolute w-[7px] h-[100%]  translate-x-[-50%]  top-0 left-[50%] lg:block hidden "
            style={{
              // backgroundColor: "#00FF8F",
              height: `${yellowHeight}px`,
              background: "linear-gradient(180deg,#00FF8F 0%,#33B4FF 100%)",
            }}
          ></div>

          <div className="grid md:grid-cols-2 md:gap-20 gap-6  ">
            <div className="lg:max-w-[425px] flex-col flex justify-center  ">
              <h2 className="CustomStartHead  text-[#F24F96] pb-[5rem] relative ">
                <span className=" relative top-0 ">The Problem</span>
                <img
                  src={theProblemHeadImg}
                  width={321}
                  className=" absolute bottom-[-2.5rem] md:left-[-1.6rem] left-[50%] md:translate-x-0 translate-x-[-50%]  "
                  height={73}
                  alt=""
                />
              </h2>
              <h2 className="CustomStartPara !font-normal   ">
                As a creator, you’re likely cooking up a bunch of different
                projects at any given time. So why do tipping platforms only
                allow you to set up one goal at a time?
              </h2>
            </div>
            <div className=" mx-auto ">
              <img
                src={problem}
                alt=""
                width={283}
                height={459}
                className=" sm:w-[300px] sm:h-[459px] w-[220px] h-[280px]   object-contain "
              />
            </div>
          </div>
          <div className="grid md:grid-cols-2 md:gap-20 gap-6 lg:pt-[8rem] pt-[6rem] ">
            <div className="lg:max-w-[500px] md:order-2 lg:pl-5 flex flex-col justify-center ">
              <h2 className="CustomStartHead !text-center  text-[#33B4FF] pb-16  relative ">
                <span>The Solution</span>
                <img
                  src={theSolutionHeadImg}
                  className=" sm:w-[382px] sm:h-[140px] w-[300px] h-[90px] absolute sm:bottom-[0.2rem] bottom-[2.2rem] left-[50%] translate-x-[-55%] "
                  alt=""
                />
              </h2>
              <h2 className="CustomStartPara !font-normal ">
                Introducing SPONSA – a new tipping platform created by creators
                for creators, allowing you to set up multiple tip goals, all at
                once.
              </h2>
            </div>
            <div className="sm:mr-auto mx-auto sm:mt-0 mt-6 mb-auto  ">
              <img
                src={solution}
                alt=""
                width={460}
                height={471}
                className="sm:w-[460px] sm:h-[471px] w-[300px] h-[300px]  "
              />
            </div>
          </div>
          <div className="grid md:grid-cols-2 md:gap-20 gap-6 lg:pt-[10rem] pt-[8rem]  ">
            <div className="lg:max-w-[395px] flex flex-col justify-center">
              <h2 className="CustomStartHead  text-[#FFD50E] pb-8 relative ">
                <span>Create goals for:</span>
                <img
                  src={creategoalHeadImg}
                  width={166}
                  className=" absolute bottom-[0.6rem] right-[-1rem]  "
                  height={102}
                  alt=""
                />
              </h2>
              <h2 className="CustomStartPara !font-normal ">
                Anything! Your imagination is your limit! We give you the tools.
                You do the creating.
              </h2>
            </div>
            <div className="mx-auto">
              <img
                src={CreateGoalFor}
                alt=""
                width={403}
                height={255}
                className=" sm:w-[403px] sm:h-[255px] w-[300px] h-[180px]   "
              />
            </div>
          </div>
        </div>
        <div
          className="mx-auto w-full flex justify-center md:py-[5rem]  pt-0 pb-[4rem]  "
          id="faqs"
          ref={faqsRef}
        >
          <button
            className=" HoverDarker rounded-[50px] px-11 py-3  bg-[#00FF8F]  text-[25px]  font-bold text-black leading-[30px] tracking-normal text-center border-none    CustomButtonAnim "
            onClick={handleClick}
          >
            Start Now
          </button>
        </div>
        <div className=" md:bg-contain bg-cover bg-center bg-no-repeat Landingceleberation  px-4 mb-[6rem] w-full md:py-[10rem] py-[6rem] flex items-center justify-center ">
          <div className=" space-y-4  ">
            <h2 className=" font-bold lg:text-[60px] md:text-[40px] text-[30px] leading-[100%] tracking-[0%] text-center text-white    ">
              Total raised on SPONSA
            </h2>
            <p className=" font-bold lg:text-[110px] md:text-[80px] text-[60px] leading-[100%] tracking-[0%] text-center      ">
              <AnimatedNumber value={500000} duration={500} />
            </p>
          </div>
        </div>

        <div>
          <Faqs />
        </div>
        <div className="mx-auto w-full flex justify-center md:py-[5rem]  py-[4rem]">
          <button
            className=" HoverDarker rounded-[50px] px-11 py-3  bg-[#00FF8F]  text-[25px]  font-bold text-black leading-[30px] tracking-normal text-center border-none  CustomButtonAnim "
            onClick={handleClick}
          >
            Start Now
          </button>
        </div>
      </div>
    </>
  );
}

export default NewHome;
